<template>
  <CraftAsset
    :ratio="16 / 9"
    sizes="100vw sm:100vw"
    :asset="asset"
    :autoplay="true"
    crop="fill"
    class="max-w-none object-cover w-full h-full"
    role="presentation"
  />
</template>

<script setup>
import CraftAsset from '@/components/common/CraftAsset';

defineProps({
  asset: {
    type: Object,
    required: true,
  },
});
</script>
